export default "__VITE_ASSET__B8D8KFJq__"